import {Controller} from "angular-ecmascript/module-helpers";
import Store from "store/store";

export default class ViewController extends Controller {

    constructor($scope, $viewService) {
        super(...arguments);

        this.hasViewParams = false;
        this.viewParams = {};

        var self = this;
        this.$scope.$on("$ionicView.beforeEnter", () => {
            if (self.hasViewParams) {
                self.loadViewParams();
            }
        });

        this.$scope.$on("$ionicView.afterLeave", () => {
            if (self.hasViewParams) {
                self.clearViewParams();
            }
        });

        this.createViewCallback("$ionicView.loaded", '$onViewLoaded');
        this.createViewCallback("$ionicView.enter", '$onViewEnter');
        this.createViewCallback("$ionicView.leave", '$onViewLeave');
        this.createViewCallback("$ionicView.beforeLeave", '$onViewBeforeLeave');
        this.createViewCallback("$ionicView.beforeEnter", '$onViewBeforeEnter');
        this.createViewCallback("$ionicView.afterLeave", '$onViewAfterLeave');
        this.createViewCallback("$ionicView.afterEnter", '$onViewAfterEnter');
        this.createViewCallback("$ionicView.unloaded", '$onViewUnloaded');
    }

    createViewCallback(eventName, methodName) {
        if (typeof this[methodName] === 'function') {
            var self = this;
            this.$scope.$on(eventName, function (event, data) {
                self[methodName].call(self, event, data);
            });
        }
    }

    toState(targetState, params) {
        if (params) {
            Store.set(targetState + '.params', params);
        }

        this.$state.go(targetState);
    }

    loadViewParams() {
        if (!this.$state || !this.$state.$current) {
            return;
        }

        let stateName = this.$state.$current.self.name;
        this.viewParams = Store.get(stateName + '.params');
        if (!this.viewParams) {
            this.viewParams = {};
        }
    }

    clearViewParams() {
        if (!this.$state || !this.$state.$current) {
            return;
        }

        let stateName = this.$state.$current.self.name;
        Store.remove(stateName + '.params');
    }

    viewParam(name, defaultValue) {
        if (!this.viewParams || !this.viewParams[name]) {
            return defaultValue;
        }

        return params[name];
    }

    viewState(name, data) {
        if (arguments.length == 2) {
            if (data) {
                Store.set(name, data);
            } else {
                Store.remove(name);
            }
        } else {
            return Store.get(name);
        }
    }

    stateParam(name, defaultValue) {
        let value = this.$state.params[name];
        return value != null ? value : defaultValue;
    }

}



// WEBPACK FOOTER //
// ./src/modules/core/views/view.controller.js